
(function roleAddControllerDefinition() {
    'use strict';

    angular.module('Role')
        .controller('RoleAddController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'adminRoleService', 'authExtend', 'auth', 'functionService',
            function roleAddController($scope, config, $state, $translate, errors, adminRoleService, authExtend, auth, functionService) {
                $scope.canAssociateAd = auth.isInRole('ROLES ASSOCIATE AD');

                $scope.allApps = authExtend.isInRole('CONFIG ADMIN APPS');                
                if ($scope.allApps) {
                    functionService.getApps().then(function getOk(result) {
                        $scope.optionApps = result;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                }

                $scope.title = 'RoleAdd';
                $scope.role = {
                    name: "",
                    organizationalUnitId: authExtend.getOrganizationId(),
                    organizationalUnitName: authExtend.getOrganizationName(),
                    adGroups: []
                };

                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;


                $scope.save = function(){
                    if (!$scope.roleForm.$valid) {
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if ($scope.role.application) {
                        $scope.role.applicationId = $scope.role.application.id;
                    }
                    return adminRoleService.create($scope.role).then(function (role) {
                        if (role) {
                                $state.go('role-functions', { id: role.id });
                            } else {
                                $state.go('role-find');
                            }
                        },
                        function (error) {
                            errors.showError(error);
                        });
                };

                $scope.cancel = function () {
                    $state.go("role-find");
                };

            }
        ]);
})();